import { Outlet, useLocation } from "react-router-dom";
import AsideProfile from "./components/AsideProfile";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import { useDarkMode } from "./context/DarkModeContext";
import MoonIcon from "./components/icons/MoonIcon";
import SunIcon from "./components/icons/SunIcon";
import { AnimatePresence } from "framer-motion";

export default function AppLayout() {
  const { isDarkMode, toggleDarkMode } = useDarkMode();
  const location = useLocation();

  return (
    <div className="relative mx-auto flex max-w-[2800px] gap-8 bg-portfolio-page px-24 text-portfolio-text [@media(min-height:900px)]:h-screen [@media(min-height:900px)_and_(min-width:1025px)]:items-center [@media(min-height:900px)_and_(min-width:1025px)]:px-24 [@media(min-height:900px)_and_(min-width:1025px)]:py-16 max-[1024px]:flex-col max-[1024px]:items-center max-[1024px]:gap-6 max-[1024px]:p-4 max-[500px]:gap-4">
      <div
        className="absolute left-5 top-5 z-[1000] flex size-[35px] items-center justify-center rounded-full"
        onClick={toggleDarkMode}
      >
        {isDarkMode ? <SunIcon /> : <MoonIcon />}
      </div>
      <AsideProfile />
      <main className="flex h-screen w-full flex-col bg-portfolio-surface [@media(max-height:550px)_and_(min-width:1025px)]:h-[700px] [@media(min-height:900px)_and_(min-width:1025px)]:h-[900px] max-[1024px]:h-auto max-[1024px]:w-3/4 max-[500px]:w-full">
        <NavBar />

        <AnimatePresence>
          <div
            location={location}
            key={location.pathname}
            className="relative w-full flex-grow overflow-y-scroll"
          >
            <Outlet />
            <Footer />
          </div>
        </AnimatePresence>
      </main>
    </div>
  );
}
